export default __webpack_public_path__ + "static/media/title-img.fa93c214.svg";